import React from 'react';

import './App.css';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import Header from './components/Header';
import HomePage from './pages/Homepage';
import Projects from './pages/Projects'; // Projects 페이지 추가
import Publications from './pages/Publications';
import Alumni from './pages/Alumni';
import Professor from './pages/Professor';

function App() {

  const menuItems = [
    { label: 'Home', link: '/' }, // 루트 경로로 설정
    { label: 'Professor', link: '/professor' }, // '/about' 경로로 설정
    { label: 'Projects', link: '/projects' }, // '/projects' 경로로 설정
    { label: 'Publications', link: '/publications' }, // '/publications' 경로로 설정
    { label: 'Alumni', link: '/alumni' }, // '/alumni' 경로로 설정
    { label: 'Contact', link: '/contact' }, // '/contact' 경로로 설정
  ];

  return (
    <div className="App">
      <BrowserRouter basename={process.env.PUBLIC_URL}>
        <Header menuItems={menuItems} />
        <Switch>
          <Route path="/" exact component={HomePage} /> {/* exact를 사용하여 정확한 경로와 매치 */}          
          <Route path="/professor" component={Professor} /> {/* Professor 페이지에 대한 라우트 */}
          <Route path="/projects" component={Projects} /> {/* Projects 페이지에 대한 라우트 */}
          <Route path="/publications" component={Publications} /> {/* Projects 페이지에 대한 라우트 */}
          <Route path="/alumni" component={Alumni} /> {/* Projects 페이지에 대한 라우트 */}
          {/* 다른 페이지에 대한 라우트를 추가할 수 있음 */}
        </Switch>
      </BrowserRouter>
    </div>
  );
}

export default App;
